export default {"src":"/_next/static/media/Matic.8e0d6091.svg","height":34,"width":38,"blurWidth":0,"blurHeight":0};